// Scene shading is calculated before a run, not during it: on the layout page
// ("Calculate shading") or from the simulation page's notice, and stored
// with the layout. The run uses what is stored and works nothing out in the
// browser, where leaving the page would lose the run. Every surface saved from
// the layout carries a calculation (the same set the run used to calculate:
// its modules' own shading feeds the string model even with no obstacles), and
// it must be current. Percentage-only studies do not use the scene.
export const STALE_SCENE_MESSAGE = "The shading measurement is out of date. Recalculate the scene.";

const records = (config) => [config?.pv_design, ...(config?.orientations || []).slice(1)];

/** The surfaces (1, 2, ...) whose scene shading is missing or out of date. */
export function sceneShadingPending(config) {
  if (config?.pvDetailedShading?.enabled === true) return [];
  // Not offered for a dual-axis tracker: the layout's shading describes fixed
  // rows and single-axis trackers only, and the engine does not apply it.
  if (String(config?.mountType || "").toLowerCase() === "dual_axis") return [];
  if (config?.pvLosses?.dc?.shadingMode === "percentage") return [];
  const pending = [];
  records(config).forEach((record, i) => {
    if (!record?.spacingInfo?.scene_review_required) return;
    const evidence = record?.obstacleShading;
    if (!evidence || evidence.stale || evidence.sceneVersion !== 2 || !evidence.table) pending.push(i + 1);
  });
  return pending;
}

export function sceneSimulationIssues(config, greek = false) {
  if (config?.pvLosses?.dc?.shadingMode === "percentage") return [];
  const issues = [];
  if (records(config).some((record) => record?.spacingInfo?.scene_review_required && !record.spacingInfo.module_mapping_valid)) {
    issues.push("Save and validate the physical layout before simulation.");
  }
  const pending = sceneShadingPending(config);
  if (pending.length) {
    const which = pending.join(", ");
    issues.push(greek
      ? `Οι σκιάσεις της σκηνής δεν έχουν υπολογιστεί ή δεν είναι ενημερωμένες (${pending.length > 1 ? "προσανατολισμοί" : "προσανατολισμός"} ${which}). Επιλέξτε «Υπολογισμός σκιάσεων» ή «Εκτέλεση χωρίς σκιάσεις διάταξης».`
      : `Scene shading has not been calculated or is out of date (orientation${pending.length > 1 ? "s" : ""} ${which}). Choose “Calculate shading” or “Run without layout shading”.`);
  }
  return issues;
}
